export const STAGE_UPDATE = 'STAGE_UPDATE';
export const STAGE_SUCCESS = 'STAGE_SUCCESS';

export const GET_DROPDOWN_DATA_FAILED = 'GET_DROPDOWN_DATA_FAILED';
export const GET_DROPDOWN_DATA = 'GET_DROPDOWN_DATA';
export const SET_DROPDOWN_DATA = 'SET_DROPDOWN_DATA';

export const LOAD_CLIENT_STYLE = 'LOAD_CLIENT_STYLE';
export const LOAD_CLIENT_STYLE_SUCCESS = 'LOAD_CLIENT_STYLE_SUCCESS';
export const LOAD_CLIENT_STYLE_FAILED = 'LOAD_CLIENT_STYLE_FAILED';

export const CHECK_NRIC_SESSION = 'CHECK_NRIC_SESSION';
export const CHECK_NRIC_SESSION_SUCCESS = 'CHECK_NRIC_SESSION_SUCCESS';
export const CHECK_NRIC_SESSION_FAILED = 'CHECK_NRIC_SESSION_FAILED';

export const GET_APPLICATION_DETAILS = 'GET_APPLICATION_DETAILS';
export const GET_APPLICATION_DETAILS_START = 'GET_APPLICATION_DETAILS_START';
export const GET_APPLICATION_DETAILS_SUCCESS = 'GET_APPLICATION_DETAILS_SUCCESS';
export const GET_APPLICATION_DETAILS_FAILED = 'GET_APPLICATION_DETAILS_FAILED';

export const GENERATE_OTP = 'GENERATE_OTP';
export const GENERATE_OTP_SUCCESS = 'GENERATE_OTP_SUCCESS';
export const GENERATE_OTP_FAILED = 'GENERATE_OTP_FAILED';

export const SUBMIT_APPLICATION = 'SUBMIT_APPLICATION';
export const SUBMIT_APPLICATION_SUCCESS = 'SUBMIT_APPLICATION_SUCCESS';
export const SUBMIT_APPLICATION_FAILED = 'SUBMIT_APPLICATION_FAILED';

export const UPLOAD_FILE = 'UPLOAD_FILE';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAILED = 'UPLOAD_FILE_FAILED';
export const UPDATE_LICENSE_FILES = 'UPDATE_LICENSE_FILES';
export const UPLOAD_EMPLOYEMENT_FILES = 'UPLOAD_EMPLOYEMENT_FILES';

export const VALIDATE_OTP = 'VALIDATE_OTP';
export const VALIDATE_OTP_SUCCESS = 'VALIDATE_OTP_SUCCESS';
export const VALIDATE_OTP_FAILED = 'VALIDATE_OTP_FAILED';

export const UPDATE_SOURCE = 'UPDATE_SOURCE';
export const UPDATE_SOURCE_SUCCESS = 'UPDATE_SOURCE_SUCCESS';

export const GET_MYINFO_DATA = 'GET_MYINFO_DATA';
export const GET_MYINFO_DATA_SUCCESS = 'GET_MYINFO_DATA_SUCCESS';
export const GET_MYINFO_DATA_FAILED = 'GET_MYINFO_DATA_FAILED';

export const AUTHORIZE_MYINFO = 'AUTHORIZE_MYINFO';

export const GET_CONSENTS = 'GET_CONSENTS';
export const GET_CONSENTS_SUCCESS = 'GET_CONSENTS_SUCCESS';
export const GET_CONSENTS_FAILED = 'GET_CONSENTS_FAILED';

export const LOADING_REGISTER = 'LOADING_REGISTER';
export const LOADING_UNREGISTER = 'LOADING_UNREGISTER';

export const UPDATE_FLOW_FLAGS = 'UPDATE_FLOW_FLAGS';
export const UPDATE_CUSTOMER_FLOW = 'UPDATE_CUSTOMER_FLOW';

export const LOAD_CLIENT_ID = 'LOAD_CLIENT_ID';

export const GET_CONSENTS_PDF = 'GET_CONSENTS_PDF';
